// entrypoints/db.ts
const DB_NAME = 'crawlerdataDB';
const DB_VERSION = 1;
const STORE_NAME = 'crawlerData';

// 打开数据库
export async function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = (event) => {
      resolve((event.target as IDBOpenDBRequest).result);
    };

    request.onerror = (event) => {
      reject((event.target as IDBOpenDBRequest).error);
    };
  });
}

// 保存数据
export async function saveData(key: string, data: any): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    store.put(data, key);

    tx.oncomplete = () => resolve();
    tx.onerror = (event) => reject((event.target as IDBRequest).error);
  });
}

// 追加数据
export async function appendData(key: string, newData: any): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    const request = store.get(key);

    request.onsuccess = (event) => {
      try {
        const existingData = (event.target as IDBRequest).result || [];

        // ✅ 平铺数组：无论 newData 是单个对象还是数组，都能展开追加
        const mergedData = Array.isArray(newData)
          ? [...existingData, ...newData]
          : [...existingData, newData];

        store.put(mergedData, key);
        tx.oncomplete = () => resolve();
      } catch (error) {
        reject(error);
      }
    };

    request.onerror = (event) => reject((event.target as IDBRequest).error);
    tx.onerror = (event) => reject((event.target as IDBRequest).error);
  });
}

// 读取数据
export async function getData(key: string): Promise<any> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    const request = store.get(key);

    request.onsuccess = (event) => {
      resolve((event.target as IDBRequest).result);
    };

    request.onerror = (event) => {
      reject((event.target as IDBRequest).error);
    };
  });
}

// 获取所有键
export async function getAllKeys(): Promise<string[]> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    const request = store.getAllKeys();

    request.onsuccess = (event) => {
      const keys = (event.target as IDBRequest).result;
      resolve(keys.map((key: any) => key.toString()));
    };

    request.onerror = (event) => {
      reject((event.target as IDBRequest).error);
    };
  });
}

// 删除数据
export async function deleteData(key: string): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    store.delete(key);

    tx.oncomplete = () => resolve();
    tx.onerror = (event) => reject((event.target as IDBRequest).error);
  });
}
export async function deleteExpiredData(cutoffTimestamp: number, arrayName: string): Promise<void> {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    const request = store.get(arrayName);
    console.log('检查是否有需要删除的');
    //删除淘宝数据
    request.onsuccess = () => {
      const list = request.result || [];
      const cleaned = list.filter((item: any) => item.timestamp >= cutoffTimestamp);
      store.put(cleaned, arrayName); // 必须指定 key
    };
    request.onerror = (event) => {
      reject((event.target as IDBRequest).error);
    };
  });
}

// 清空所有数据
export async function clearAllData(): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    store.clear();

    tx.oncomplete = () => resolve();
    tx.onerror = (event) => reject((event.target as IDBRequest).error);
  });
}